var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEarthGlobal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 1c6.075 0 11 4.925 11 11s-4.925 11-11 11S1 18.075 1 12 5.925 1 12 1zM7.33 16l-3.394.001a9.02 9.02 0 0 0 5.783 4.707l.125.167c-1.247-1.65-2.06-3.135-2.514-4.874zm12.734.001h-3.222c-.454 1.74-1.267 3.224-2.515 4.874l.169-.225A9.023 9.023 0 0 0 20.064 16zm-5.305 0H9.413c.405 1.265 1.061 2.39 2.027 3.668l.334.436.311.395.313-.395.334-.436c.965-1.277 1.621-2.403 2.027-3.668zm-7.77-6H3.224a9.03 9.03 0 0 0 0 4h3.754A19.61 19.61 0 0 1 6.883 12c0-.687.035-1.354.107-2zM15.169 10H9.004c-.081.64-.121 1.307-.121 2 0 .73.034 1.39.106 2.001h6.194c.072-.611.106-1.271.106-2.001 0-.693-.04-1.36-.121-2zm5.609 0h-3.595c.071.646.107 1.313.107 2 0 .716-.03 1.379-.095 2.001h3.583a9.03 9.03 0 0 0 0-4zM9.476 3.36l-.031.009A9.024 9.024 0 0 0 3.935 8h3.406A13.119 13.119 0 0 1 9.476 3.36zm2.61-.005-.231.247a10.97 10.97 0 0 0-2.445 4.4h5.351a10.976 10.976 0 0 0-2.675-4.647zm2.659.072.154.22A13.163 13.163 0 0 1 16.83 8h3.234a9.026 9.026 0 0 0-5.32-4.574z",
    fill: "#585858",
    fillRule: "evenodd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEarthGlobal);
export default __webpack_public_path__ + "static/media/earth-global.d813592c.svg";
export { ForwardRef as ReactComponent };